<template>
  <section class="container__button">
    <button
      @click="btnAbort"
      class="container__button-close"
      :class="{ 'with-border': showBorder }"
    >
      <span aria-hidden="true" :style="`font-size: ${fontSize}px`"
        >&#10005;</span
      >
    </button>
  </section>
</template>

<script>
export default {
  name: "ButtonClose",

  data() {
    return {};
  },
  props: {
    fontSize: { type: String, required: false, default: "20" },
    showBorder: { type: Boolean, required: false, default: true }
  },
  methods: {
    btnAbort() {
      this.$emit("btnAbort");
    }
  }
};
</script>

<style scoped>
.container__button {
  position: sticky;
  left: calc(100% - 40px);
  top: 1%;
  display: flex;
  width: 100%;
  max-width: 30px;
  height: 100%;
  max-height: 30px;
  z-index: 1;
  padding: 3px;
}
.container__button-close {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: none; /* sin borde por defecto */
}
.container__button-close.with-border {
  border: 1px solid var(--lightbackground2);
}
.container__button-close:hover {
  transform: scale(1.1);
  background: var(--lighterbackground);
}
</style>
